import ExcelJS from "exceljs";
import { saveAs } from "file-saver";  

export const exportToExcel = async (
  myData,  
) => {
 
  // console.log("rangAge::", rangAge);

  // Create workbook and worksheet
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Report");

  // Merge cells for title and subtitle
  sheet.mergeCells("A1:Q1");
  sheet.mergeCells("A2:Q2");

  // ===========================================================
  // 1) HEADER ROWS
  // ===========================================================
  const headerRow1 = sheet.addRow([
    "លរ.\nNO.", 
    "គោត្តនាមនិងនាម\nName of household", 
    "គោត្តនាមនិងនាម\nName of household\n( La Tinh)", 
    "ភូមិ\nHamlet", 
    "ភូមិ\nHamlet\n( La Tinh)", 
    "ឃុំ\nCommune\n", 
    "ឃុំ\nCommune\n( La Tinh)", 
    "ស្រុក\nDistrict", 
    "ស្រុក\nDistrict\n( La Tinh)", 
    "ខេត្ត\nProvince", 
    "ខេត្ត\nProvince\n( La Tinh)", 
    "លេខទូរស័ព្ទ\nNumber Phone",  
    "ផ្សេងៗ\nNote",
  ]);  

  // ===========================================================
  // 3) FONT & ALIGNMENT FOR HEADER ROWS
  // ===========================================================
  [headerRow1].forEach(row => {
    row.eachCell(cell => {
      cell.font = { name: "Khmer OS Siemreap", bold: true, size: 11 };
      cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    });
  });

  // ===========================================================
  // 4) DEFINE COLUMNS WITH WIDTHS
  // ===========================================================
  sheet.columns = [
    { header: "លរ.\nNO.", key: "no", width: 6 },
    { header: "គោត្តនាមនិងនាម\nName of household", key: "Nameofhousehold", width: 20 },
    { header: "គោត្តនាមនិងនាម\nName of household\n( La Tinh)", key: "NameofhouseholdLatin", width: 20 },
    { header: "ភូមិ\nHamlet", key: "Village", width: 20 },
    { header: "ភូមិ\nHamlet\n( La Tinh)", key: "VillageLatin", width: 20 },
    { header: "ឃុំ\nCommune\n", key: "Commune", width: 20 },
    { header: "ឃុំ\nCommune\n( La Tinh)", key: "CommuneLatin", width: 20 },
    { header: "ស្រុក\nDistrict", key: "District", width: 20 },
    { header: "ស្រុក\nDistrict\n( La Tinh)", key: "DistrictLatin", width: 20 },
    { header: "ខេត្ត\nProvince", key: "Province", width: 20 },
    { header: "ខេត្ត\nProvince\n( La Tinh)", key: "ProvinceLatin", width: 20 },
    { header: "លេខទូរស័ព្ទ\nNumber Phone", key: "NumberPhone", width: 20 },
    { header: "ផ្សេងៗ\nNote", key: "Note", width: 20 }, 
  ];

  // ===========================================================
  // 5) SET TITLE & SUBTITLE
  // ===========================================================
  const title = sheet.getCell("A1");
  title.value = `បញ្ជីចែកចាយចង្ក្រានសន្សំសំចៃថាមពលនៅកម្ពុជា`;
  title.font = { name: "Khmer OS Muol Light", size: 13 };
  title.alignment = { vertical: "middle", horizontal: "center" };
  sheet.getRow(1).height = 30;

  const subtitle = sheet.getCell("A2");
  subtitle.value = `DISTRIBUTION OF IMPROVED COOKSTOVE IN CAMBODIA`;
  subtitle.font = { name: "Khmer OS Muol Light", size: 13 };
  subtitle.alignment = { vertical: "middle", horizontal: "center" };
  sheet.getRow(2).height = 25;

  // ===========================================================
  // 6) ADD DATA ROWS
  // ===========================================================
  const rowsData = myData?.map(d => [
    d.no, 
    d.Nameofhousehold, 
    d.NameofhouseholdLatin, 
    d.Village, 
    d.VillageLatin, 
    d.Commune, 
    d.CommuneLatin,
    d.District, 
    d.DistrictLatin, 
    d.Province, 
    d.ProvinceLatin,
    d.NumberPhone, 
    d.Note,
  ]);

  const rows = rowsData.map(data => sheet.addRow(data));

  // Row styling
  const imageCol = 16; // Column Q (0-based index 16)
  rows.forEach(row => {
    row.height = 25;
    row.eachCell((cell, colNumber) => {
      cell.font = { name: "Khmer OS Siemreap", size: 11 };
      cell.alignment = { vertical: "middle", horizontal: "center", wrapText: colNumber !== imageCol+1 };
    });
  });

  // ===========================================================
  // 7) ADD IMAGES
  // ===========================================================
  const imagePromises = myData.map(async (d, i) => {
    try {
      if (!d.image) return;
      const res = await fetch(d.image);
      const buffer = await res.arrayBuffer();
      const imageId = workbook.addImage({ buffer, extension: "png" });
      const rowNumber = rows[i].number;
      const margin = 0;
      sheet.addImage(imageId, {
        tl: { col: imageCol + margin, row: rowNumber - 1 + margin },
        br: { col: imageCol + 1 - margin, row: rowNumber - margin }
      });
    } catch (err) {
      console.log("Image failed:", d.image, err);
    }
  });
  await Promise.all(imagePromises);

  // ===========================================================
  // 8) EXPORT
  // ===========================================================
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), "report.xlsx");
};
